<mat-card appearance="outlined" class="container">
  <mat-card-header class="secondary-background-element main-card flex-center">


    <div class="shop-filter">
      <button mat-button [matMenuTriggerFor]="filterRole">
        <span class='mat-body flex-center'><span class='v-middle'>{{getShownShop()}}</span>
        <mat-icon svgIcon="dropdownMenu" class="secondary-contrast-icon"></mat-icon>
      </span>
    </button>
    <mat-menu #filterRole="matMenu" xPosition="before">
      <button (click)="setShopFilter( ShopFilterStates.all)" mat-menu-item>All shops</button>
      @for (shop of shopList; track shop) {
        <button (click)="setShopFilter(ShopFilterStates.oneShop,shop)" mat-menu-item>{{shop.shopId}}<br>
          <p class="mat-small">{{[shop.shopName,shop.addressLine1, shop.addressLine2,shop.city].join(' ')}}</p></button>
        }

      </mat-menu>
    </div>

    <span class="spacer"></span>

    <button mat-icon-button (click)="refreshTable()" class="flex-child-wrapper">
      <mat-icon svgIcon="refresh"></mat-icon>
    </button>
  </mat-card-header>

  <mat-card-content>


    <!--  table columns definitions -->
    <table mat-table matSort color="accent" class='closer-sort' aria-label="Elements" [dataSource]="dataSource"
      [matSortActive]="this.dataSource.sortingHeader" [matSortDirection]="this.dataSource.sortDirection">


      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <h3>Name</h3>
        </th>
        <td mat-cell *matCellDef="let row" [matTooltip]="'Date of birth: '+ row.dateOfBirth">
          <h3 class="not-bold">{{row.firstName}} {{row.lastName}}</h3>
        </td>
      </ng-container>

      <ng-container matColumnDef="patientId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <h3>Patient ID</h3>
        </th>
        <td mat-cell *matCellDef="let row">
          <span>{{row.patientId}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <h3>E-mail</h3>
        </th>
        <td mat-cell *matCellDef="let row">
          @if (row.email) {
            <div>
              {{row.email}}
            </div>
          } @else {
            <mat-icon svgIcon='dash'></mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="shopId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <h3>Shop ID</h3>
        </th>
        <td mat-cell *matCellDef="let row" [matTooltip]="row.shopName+'\n'+row.shopAddress">
          @if (row.shopId) {
            <div>
              <span>{{row.shopId}}</span>
            </div>
          } @else {
            <mat-icon svgIcon='dash'></mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="lastSeen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <h3>Last Seen</h3>
        </th>
        <td mat-cell *matCellDef="let row" [matTooltip]="formatDate(row.lastSeen, 'yyyy-MM-dd', 'en-US')">
          @if (row.lastSeen) {
            <div>
              <span>{{getRelativeDateTimeWithDaysMonthAgo(row.lastSeen)}}</span>
            </div>
          } @else {
            <mat-icon svgIcon='dash'></mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="dateOfRegistration">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <h3>Date of Registration</h3>
        </th>
        <td mat-cell *matCellDef="let row" [matTooltip]="formatDate(row.dateOfRegistration, 'yyyy-MM-dd', 'en-US')">
          @if (row.dateOfRegistration) {
            <div>
              <span>{{getRelativeDateTimeWithDaysMonthAgo(row.dateOfRegistration)}}</span>
            </div>
          } @else {
            <mat-icon svgIcon='dash'></mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <h3>Actions</h3>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="flex actions">

            <button matTooltip="Reset password" mat-icon-button (click)="resetPassword(row)" [disabled]="row.authSource!=null">
              <mat-icon class='accent-icon larger' [ngClass]="{'secondary-icon':row.authSource!=null,'accent-icon':row.authSource==null}"  svgIcon="resetPassword"></mat-icon>
            </button>

            @if (!row.isPendingDeletion) {
              <button matTooltip="Delete patient" mat-icon-button (click)="deletePatient(row)">
                <mat-icon class='accent-icon larger' svgIcon="deleteUser"></mat-icon>
              </button>
            }

            @if (row.isPendingDeletion) {
              <button style="pointer-events: auto;" matTooltip="Pending Deletion" mat-icon-button disabled="true">
                <mat-icon class='accent-icon larger' svgIcon="pendingDelete"></mat-icon>
              </button>
            }

            <button matTooltip="Transfer patient to another clinic" mat-icon-button (click)="transferPatient(row)">
              <mat-icon class='accent-icon larger' svgIcon="transfer"></mat-icon>
            </button>

        </div>


      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>

  <!-- progress indicator that we are to indicate that data is being loaded from the backend  -->
  @if ((this.dataSource.loading$ | async); as loading) {
    <div class="spinner-container">
      <mat-spinner color="accent" [diameter]="30" class="spinner-diametser-30"></mat-spinner>
    </div>
  }

  <mat-paginator color='accent' [length]="dataSource.count" [pageIndex]=" this.dataSource.pageIndex"
    [pageSize]="this.dataSource.pageSize" [pageSizeOptions]="[10,20,50]">
  </mat-paginator>
</mat-card-content>
</mat-card>

<ng-template #sentButton>
  <button mat-icon-button disabled class="immitation-button">
    <mat-icon svgIcon='checkmark' class="sent-button-icon secondary-contrast-icon"></mat-icon>
  </button>

</ng-template>